import React from 'react';
import { useTranslation } from 'react-i18next';
import { LiliDrawer } from '@lili/lili-frontend-common';
import { useStore } from '../../../../store';
import { LinkedAccount } from '../../hooks/useLinkedAccounts';
import ManageCards from './ManageCards/ManageCards';
import SyncedCard from './SyncedCard';
import { featureAccess, LimitedFeatureType } from '../../../../services/appAccess.service';
import { FeatureAccess } from '../../../AccountSettings/components/rolesAndPermissions/PermissionsList';

interface SyncedCardsWrapperProps {
  syncedCards: LinkedAccount[];
  isLoading: boolean;
}

const SyncedCardsWrapper = (props: SyncedCardsWrapperProps) => {
  const { syncedCards, isLoading } = props;
  const [isManagemantDrawerOpen, setIsManagemantDrawerOpen] = React.useState<boolean>(false);
  const { selectedSyncedCard, setSelectedSyncedCard } = useStore((state) => state);
  const { t } = useTranslation();
  const transactionsListPermission = featureAccess(null, LimitedFeatureType.TransactionsListView);

  return (
    <div className='w-full h-[84px] bg-bw02 border-[1px] border-bw03 rounded-[8px] my-[24px] relative'>
      <div className='flex items-center p-[16px] gap-[12px]'>
        {syncedCards.map((card) => (
          <SyncedCard
            key={card.externalId}
            card={card}
            selected={card.externalId === selectedSyncedCard?.externalId}
            onClick={(selectedCard) => setSelectedSyncedCard(selectedCard)}
            isLoading={isLoading}
          />
        ))}
        {transactionsListPermission === FeatureAccess.READ_WRITE && (
          <div className='absolute right-[24px] bottom-[16px]'>
            <button
              type='button'
              className='text-action03 font-metricR text-[14px] hover:underline cursor-pointer'
              onClick={() => setIsManagemantDrawerOpen(true)}
            >
              {t('TRANSACTIONS_FACELIFT.SYNC_CARD.MANAGE_CARDS')}
            </button>
          </div>
        )}
      </div>
      <LiliDrawer
        visible={isManagemantDrawerOpen}
        onHide={() => setIsManagemantDrawerOpen(false)}
        header={t('TRANSACTIONS_FACELIFT.SYNC_CARD.MANAGE')}
      >
        <ManageCards syncedCards={syncedCards} />
      </LiliDrawer>
    </div>
  );
};

export default SyncedCardsWrapper;
